import axios from 'axios'

export const deleteIcon = async (program, icon) => {
    try {
      return await axios.delete(`/organization/${program.organization_id}/event_icons/${icon.id}`);
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
}

export const fetchEventIcons = async(program, include = '') => {
    try {
        let url = `/organization/${program.organization_id}/event_icons`
        if( include )   {
            url += '?include=' + include
        }
        const response = await axios.get(url);
        return response.data
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

export const getEventLedgerCodes = async(organizationId, programId) => {
    try {
        const response = await axios.get(`/organization/${organizationId}/program/${programId}/ledgercode`);
        return response.data
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
  };



  export const fetchEventSocialWallImages = async(program, include = '') => {
    try {
        let url = `/organization/${program.organization_id}/event_social_wall_images`
        if( include )   {
            url += '?include=' + include
        }
        const response = await axios.get(url);
        return response.data
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

export const deleteSocialWallImage = async (program, icon) => {
    try {
      return await axios.delete(`/organization/${program.organization_id}/event_social_wall_images/${icon.id}`);
    } catch (e) {
      throw new Error(`API error:${e?.message}`);
    }
}